import { render, staticRenderFns } from "./TableHeaders.vue?vue&type=template&id=77832073&scoped=true"
import script from "./TableHeaders.vue?vue&type=script&lang=js"
export * from "./TableHeaders.vue?vue&type=script&lang=js"
import style0 from "./TableHeaders.vue?vue&type=style&index=0&id=77832073&prod&scoped=true&lang=scss"
import style1 from "./TableHeaders.vue?vue&type=style&index=1&id=77832073&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77832073",
  null
  
)

export default component.exports